/**
 * Calls the BFF's event-intake endpoint: the poster image (+ optional notes) goes
 * up as multipart; the BFF gathers the organiser's recent events + master data and
 * runs ONE Gemini call, returning a structured `{ event, sources, summary, warnings }`.
 * Best-effort — returns null on any failure so the caller falls back to the
 * deterministic history base.
 */
import httpClient from "http-client/http-client";
import { renderErrorNotifications } from "helpers/error.helpers";

/**
 * @param {object} params
 * @param {File}   params.file    the uploaded poster image
 * @param {string} [params.notes] optional free-text the organiser typed
 * @returns {Promise<{event, sources, summary, warnings}|null>}
 */
export async function fetchPosterIntake({ file, notes }) {
  try {
    const formData = new FormData();
    formData.append("file", file);
    if (notes) formData.append("notes", notes);

    const { data, errors } = await httpClient.post({
      url: "v1/community-portal/event/intake",
      body: formData,
    });
    if (errors && errors.length > 0) {
      renderErrorNotifications(errors);
      return null;
    }

    const intake = data?.intake;
    return intake && typeof intake === "object" && intake.event ? intake : null;
  } catch {
    return null;
  }
}
